module.exports = __webpack_public_path__ + "img/vip-icon4.5daae85e.png";